export const getCookiePreferences = () => {
  const saved = localStorage.getItem("cookieConsent");

  if (!saved) {
    return null;
  }

  return JSON.parse(saved);
};

export const canUsePerformanceCookies = () => {
  const prefs = getCookiePreferences();
  return prefs?.performance === true;
};

export const canUseTargetingCookies = () => {
  const prefs = getCookiePreferences();
  return prefs?.targeting === true;
};

export const canUseFunctionalCookies = () => {
  const prefs = getCookiePreferences();
  return prefs?.functional === true;
};